import React from 'react';
import './Header.css';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1
    },
    appBar: {
        backgroundColor: "var(--color-white)",
        color: "var(--color-primary)",
        borderBottom: "2px solid var(--color-primary)"
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));

export default function Header() {
    const classes = useStyles();

    return (<div className={classes.root}>
        <AppBar className={classes.appBar} position="static">
          <Toolbar>
            <Typography variant="h6" color="inherit">
              VuFinder
            </Typography>
          </Toolbar>
        </AppBar>
      </div>)
}